require('./movementTypeFilter.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ commons
const OKSelect = require('components/commons/OKSelect/OKSelect');
const CountryHelper = require('utilities/countryHelper');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
// @ constants
const { TYPES, CONCEPTS, CONCEPTS_PT } = require('constants/movementsTypes');

const COUNTRY_PT_CODE = 'PT';

class MovementTypeFilter extends React.Component {
    constructor(props) {
        super(props);
        const { immFilter, immProfile } = props;
        const movementType = immFilter.getIn(['movementType','movementType']) || TYPES.ALL;
        this.state = {
            typeSelected: movementType,
            concept: immFilter.getIn(['concept','concept']) || TYPES.ALL,
        };
        this.country = CountryHelper.getOriginCountry(immProfile.get('originCountry'));
        this.handleConceptChange = this.handleConceptChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
    }

    getConcepts(type) {
        let conceptsList = this.country === COUNTRY_PT_CODE? CONCEPTS_PT : CONCEPTS;

        if (type !== TYPES.ALL) {
            conceptsList = conceptsList.filter(
                conceptObj => conceptObj.type === type
            );
        }

        return conceptsList.map(({key: value, label}) => ({
            value,
            label: formatText(label)
        }));
    }

    conceptExists(options, concept) {
        return options.find((conceptObj)=>{
            return conceptObj.value === concept;
        });
    }

    handleConceptChange(concept) {
        this.setState({
            concept: concept.value
        });

        this.props.onConceptChange(concept.value);
    }

    handleTypeChange(value) {
        let desiredType = value;

        if (value === TYPES.ALL) {
            desiredType = null;
        }

        this.setState({
            typeSelected: value
        });

        this.props.onTypeChange(desiredType);
    }

    render() {
        const { concept, typeSelected } = this.state;
        const options = this.getConcepts(typeSelected);
        const allLabel = <FormattedText value="movementTypeFilter-allLabel" className="movement-type-filter__radio-option-label"/>;
        const depositLabel = <FormattedText value="movementTypeFilter-depositLabel" className="movement-type-filter__radio-option-label"/>;
        const expensesLabel = <FormattedText value="movementTypeFilter-expenseLabel" className="movement-type-filter__radio-option-label"/>;

        let selectCurrentValue = concept;

        //if option selected not exists we use the first one.
        //This happens when you change movementType and the current one isn't retrived on the options array.
        if (!this.conceptExists(options, concept)) {
            selectCurrentValue = options[0].value;
        }

        return (
            <section className="movement-type-filter">
                <header className="movement-type-filter__title">
                    <FormattedText value="movementTypeFilter-typeTitle" />
                </header>
                <RadioButtonGroup
                    name="chequebook-filter"
                    idPrefix="chequebook-filter-radio"
                    selectedValue={this.state.typeSelected}
                    onChange={this.handleTypeChange}
                    className="chequebook-filter__options"
                >
                    <RadioButton
                        className="movement-type-filter__radio-option"
                        label={allLabel}
                        value={TYPES.ALL}
                    />
                    <RadioButton
                        className="movement-type-filter__radio-option"
                        label={depositLabel}
                        value={TYPES.DEPOSIT}
                    />
                    <RadioButton
                        className="movement-type-filter__radio-option"
                        label={expensesLabel}
                        value={TYPES.EXPENSE}
                    />
                </RadioButtonGroup>
                <div className="row">
                    <div className="movement-type-filter__concept col-xs-6">
                        <div className="movement-type-filter__title movement-type-filter__title--concept-title">
                            <FormattedText value="movementTypeFilter-conceptTitle" />
                        </div>
                        <OKSelect
                            name="movement-type-filter-dropdown"
                            onChange={this.handleConceptChange}
                            value={selectCurrentValue}
                            options={options}
                            searchable={false}
                            clearable={false}
                            openUp={true}
                        />
                    </div>
                </div>
            </section>
        );
    }
}

MovementTypeFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onConceptChange: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    immProfile: PropTypes.Object
};

module.exports = MovementTypeFilter;